import { jsxs as c, jsx as l } from "react/jsx-runtime";
const h = () => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    viewBox: "0 0 16 16",
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_40941_3479)", children: /* @__PURE__ */ l(
        "path",
        {
          fill: "#EC3F3F",
          d: "M7.031.6a1.082 1.082 0 011.937 0l3.366 6.73 3.55 7.102c.36.72-.164 1.568-.969 1.568H1.085a1.083 1.083 0 01-.969-1.568l3.55-7.102L7.031.6zM8 11c.375 0 .687-.29.712-.665l.28-4.095C9.066 5.582 8.602 5 8 5s-1.066.582-.992 1.24l.28 4.095A.714.714 0 008 11zm1 2.012v-.024C9 12.43 8.576 12 8 12c-.575 0-1 .43-1 .989v.023c0 .557.425.988 1 .988.576 0 1-.432 1-.988z"
        }
      ) }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_40941_3479", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 0H16V16H0z" }) }) })
    ]
  }
), t = () => /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", children: /* @__PURE__ */ c("g", { fill: "none", children: [
  /* @__PURE__ */ l("circle", { cx: "8", cy: "8", r: "8", fill: "#2196F3" }),
  /* @__PURE__ */ c("g", { fill: "#FFF", transform: "translate(6.5 4)", children: [
    /* @__PURE__ */ l("circle", { cx: "1.5", cy: "1", r: "1" }),
    /* @__PURE__ */ l("rect", { width: "2", height: "5", x: "0.5", y: "3", rx: "1" })
  ] })
] }) }), n = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l("circle", { cx: "8", cy: "8", r: "8", fill: "#4BB4B3" }),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M4.78033 7.84467C4.48744 7.55178 4.01256 7.55178 3.71967 7.84467C3.42678 8.13756 3.42678 8.61244 3.71967 8.90533L5.96967 11.1553C6.26256 11.4482 6.73744 11.4482 7.03033 11.1553L12.2803 5.90533C12.5732 5.61244 12.5732 5.13756 12.2803 4.84467C11.9874 4.55178 11.5126 4.55178 11.2197 4.84467L6.5 9.56434L4.78033 7.84467Z",
          fill: "white"
        }
      )
    ]
  }
), r = () => /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", children: /* @__PURE__ */ l(
  "path",
  {
    fill: "#FFAD3A",
    d: "M8 0a8 8 0 110 16A8 8 0 018 0zm0 10.7c-.4 0-.7.1-1 .4-.2.2-.3.5-.3.9s.1.7.4 1c.2.2.5.3.9.3s.7-.1 1-.4c.2-.2.3-.5.3-.9s-.1-.7-.4-1c-.2-.2-.5-.3-.9-.3zm1.2-7.4c-.3-.5-.9-.7-1.5-.6-.6.2-1 .7-1 1.3v1L7 9.3c0 .5.5.8 1 .8.6 0 1-.4 1-.8v-.9l.2-2.6.1-1.8v-.6z"
  }
) });
export {
  h as ErrorIcon,
  t as InfoIcon,
  n as SuccessIcon,
  r as WarningIcon
};
